import InfoTip, {P} from '../../../components/info-tip/info-tip';

const IPAddressInfo = function () {
  return (
    <InfoTip
      info={
        <section className={'text-[12px] w-[300px]'}>
          <h3>IP位置</h3>
          <P>
            請查詢貴公司對外固定ＩＰ，使用在網頁打卡功能
            <br />
            1.查詢後，重開電信公司提供的數據機
            <br />
            2.再重新查詢一次對外IP
            <br />
            3.正常來說，若還是同樣的IP位置，就是固定IP，如果換成其他IP就是浮動
            <br />
            4.直接與電信業者確認貴公司是否有固定IP服務，也是一個方式
          </P>
        </section>
      }
    />
  );
};

export default IPAddressInfo;
